var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_3365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.124 10.2245L24 8.52484L12.0913 4.8609L0 9.07555L4.87598 10.5757L0 12.2754L4.87598 13.7755L0 15.4752L11.9087 19.1391L24 14.9245L19.124 13.4243L24 11.7247L19.124 10.2245ZM12.1185 6.33986L19.4908 8.60814L11.8815 11.2605L4.50921 8.99229L12.1185 6.33986ZM7.14422 11.2736L11.9087 12.7395L16.883 11.0056L19.4908 11.8079L11.8815 14.4603L4.50921 12.1921L7.14422 11.2736ZM19.4908 15.0077L11.8815 17.6601L4.50921 15.3919L7.14422 14.4734L11.9088 15.9394L16.8831 14.2055L19.4908 15.0077Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_3365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLayers);
export default __webpack_public_path__ + "static/media/icon-layers.5abb464f5a3f148f3aade7daf7799574.svg";
export { ForwardRef as ReactComponent };